import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CARD_ERRORS, TRANSACTION_TYPE } from "../utils/constants";
import TickSmallCheck from "../images/tick_small_edit.png";
import React, { useState, useEffect } from "react";
import { tipPrice } from "../utils/rules";
import { connect, useDispatch, useSelector } from "react-redux";
import {
    setAlert,
    updateCcVerification,
    setCreditCardForm,
    setPosts,
} from "../../redux/actions";
import CloseButton from "../common/CloseButton";
import Avatar from "./Avatar";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { TextField } from "@mui/material";
import { InputAdornment } from "@material-ui/core";
import currency from "currency.js";
import PaymentOptions from "./PaymentOptions";

const SendTipModal = ({
    show,
    setShowModal,
    user,
    setTipSuccess,
    post,
    showCcVerification,
    setAmount = () => ({}),

    posts,
    tipRdx,
}) => {
    const dispatch = useDispatch();

    const [tipAmount, setTipAmount] = useState("");
    const [minSub, setMinSub] = useState(5);
    const [maxSub, setMaxSub] = useState(100);
    const [tipfees, setTipfees] = useState(0);
    const [total, setTotal] = useState(0);
    const [hasGst, setHasGst] = useState(false);
    const [GSTAmount, setGSTAmount] = useState(0);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const userInformation = JSON.parse(localStorage.getItem("user"));
    const [showGotoProfile, setShowGotoProfile] = useState(false);
    const [activeUser, setActiveUser] = useState({});
    const [cardAdded, setCardAdded] = useState(false);
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);

    const showCcForm = useSelector(
        (state) => state.privaGlobal.creditCardForm.show
    );

    const minimumAmount = 5;

    const handleClose = () => {
        setShowModal(false);
        document.body.style.overflow = "auto";
    };

    useEffect(() => {
        let mounted = true;
        if (Object.keys(user).length > 0) {
            setActiveUser(user);
        }

        return () => {
            return (mounted = false);
        };
    }, [user]);

    useEffect(() => {
        if (cardAdded) {
            setShowModal(true);
            setCardAdded(false);
        }
    }, [cardAdded]);

    const checkGST = () => {
        let response = false;

        if (user.creator && user) {
            if (
                Object.keys(user.creator).length <= 0 &&
                !user.creator.reg_gst
            ) {
                return false;
            }

            if (
                userInformation.location == "AU" &&
                user.location == "AU" &&
                user.creator.reg_gst
            ) {
                response = true;
            } else if (
                userInformation.location == "AU" &&
                user.location == "AU" &&
                !user.creator.reg_gst
            ) {
                response = false;
            } else if (
                (userInformation.location != "" &&
                    userInformation.location != "AU" &&
                    user.location != "" &&
                    user.location != "AU") ||
                !user.creator.reg_gst
            ) {
                response = false;
            } else if (
                (userInformation.location == "" ||
                    userInformation.location != "AU") &&
                user.location != "" &&
                user.creator.reg_gst
            ) {
                response = false;
            } else if (
                (user.location == "" || user.location != "AU") &&
                userInformation.location != "" &&
                userInformation.location == "AU"
            ) {
                response = true;
            } else {
                response = false;
            }
        }

        setHasGst(response);
    };

    useEffect(() => {
        getSubscriptionPrice();
    }, []);

    useEffect(() => {
        if (Object.keys(user).length > 0) {
            checkGST();
        }
    }, [user]);

    const getSubscriptionPrice = async () => {
        await axios
            .get(`/api/settings`, {
                params: {
                    only: "min_tip_price,max_tip_price",
                },
            })
            .then((response) => {
                const data = Object.assign({}, ...response.data);
                const minTip =
                    Object.keys(data).length > 0 && data.min_tip_price
                        ? data.min_tip_price
                        : tipPrice.minAmount;
                setMinSub(parseFloat(minTip));

                const maxTip =
                    Object.keys(data).length > 0 && data.max_tip_price
                        ? data.max_tip_price
                        : tipPrice.maxAmount;
                setMaxSub(parseFloat(maxTip));
            });
    };

    const handleChange = (e) => {
        const value = e.target.value;
        let tipfee = (3.1 * value) / 100;
        tipfee = tipfee + 0.3;
        tipfee = tipfee.toFixed(2);
        setTipfees(tipfee);

        let GST = parseFloat(value) * parseFloat(0.1);
        GST = GST.toFixed(2);
        const total = parseFloat(value) + parseFloat(GST);
        let fees = parseFloat(total * 0.031) + parseFloat(0.3);
        fees = fees.toFixed(2);

        setGSTAmount(GST);

        if (tipfees == "NaN" || value == "") {
            setTotal(0);
        } else {
            if (hasGst) {
                fees = parseFloat(fees) + parseFloat(GST) + parseFloat(value);
                fees = fees.toFixed(2);
                setTotal(fees);
            } else {
                let totalAmount = (
                    parseFloat(value) + parseFloat(tipfee)
                ).toFixed(2);
                setTotal(parseFloat(totalAmount));
            }
        }

        setTipAmount(e.target.value);
        if (parseFloat(e.target.value) < parseFloat(minSub)) {
            setError(`Please enter a value greater than or equal to ${minSub}`);
        } else if (parseFloat(e.target.value) > parseFloat(maxSub)) {
            setError(`Please enter a value lesser than or equal to ${maxSub}`);
        } else {
            setError("");
        }

        setShowGotoProfile(false);
    };

    const handleKeypress = (e) => {
        if (
            !(
                (e.keyCode > 95 && e.keyCode < 106) ||
                (e.keyCode > 47 && e.keyCode < 58) ||
                e.keyCode == 8 ||
                e.keyCode == 190 ||
                e.keyCode == 194 ||
                e.keycode == 108 ||
                e.keyCode == 110
            )
        ) {
            e.preventDefault(); // Let's stop this event.
            e.stopPropagation(); // Really this time.
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setShowPaymentOptions(false);
        setIsLoading(true);
        let postId = "";
        if (post && Object.keys(post).length > 0) {
            postId = post.id;
        }

        if ((!post || Object.keys(post).length > 0) && tipRdx.postId) {
            postId = tipRdx.postId;
        }

        await axios
            .post("/api/tips", {
                user: user.id,
                amount: tipAmount,
                post_id: postId,
            })
            .then((response) => {
                console.log({ response });
                setIsLoading(false);
                if (!response.data.success && response.data.url) {
                    window.location = response.data.url;
                    return;
                }

                if (!response.data.success && !response.data.url) {
                    dispatch(
                        setAlert({
                            show: true,
                            title: "",
                            body: response.data.message,
                            type: "error",
                            size: "md",
                        })
                    );
                    return;
                }

                if (
                    ((post && Object.keys(post).length > 0) ||
                        (tipRdx && tipRdx.postId)) &&
                    response.data.data &&
                    Object.keys(response.data.data).length > 0
                ) {
                    let tmpPosts = JSON.parse(JSON.stringify(posts));
                    const index = tmpPosts.findIndex(
                        (tmpPost) => tmpPost.id == post.id
                    );

                    if (index >= 0) {
                        tmpPosts[index].user_tip_total =
                            response.data.data.user_tip_total;
                    }

                    dispatch(setPosts(tmpPosts));
                }

                setTipSuccess(true);
                // setShowModal(true);
            })
            .catch((error) => {
                setIsLoading(false);
                // Card error
                if (error.response) {
                    if (error.response.status === 503) {
                        dispatch(
                            setAlert({
                                show: true,
                                type: "error",
                                body:
                                    error.response.data.message ||
                                    "Unable to process request.",
                            })
                        );
                        return;
                    }

                    if (error.response.status === 404) {
                        dispatch(
                            setCreditCardForm({
                                show: true,
                                prefilled: true,
                                closeOnly: true,
                                intent: "tip payment",
                                username: user.login,
                            })
                        );

                        dispatch(
                            setAlert({
                                show: true,
                                title: "",
                                body: error.response.data.message,
                                type: "error",
                                size: "md",
                            })
                        );
                        return;
                    }

                    if (error.response.status === 402) {
                        if (
                            error.response.data.error &&
                            error.response.data.error ===
                                CARD_ERRORS.NEEDS_VALIDATION
                        ) {
                            dispatch(
                                updateCcVerification({
                                    showVerify: true,
                                })
                            );
                            return;
                        }

                        if (
                            error.response.data.error &&
                            error.response.data.error === CARD_ERRORS.NO_CARD
                        ) {
                            dispatch(
                                setCreditCardForm({
                                    show: true,
                                    prefilled: true,
                                    closeOnly: true,
                                    intent: "tip payment",
                                    username: user.login,
                                })
                            );
                            dispatch(
                                setAlert({
                                    show: true,
                                    title: "",
                                    body:
                                        error.response.data.message ||
                                        "Please add your card details",
                                    type: "error",
                                    size: "md",
                                    mode: "add",
                                })
                            );
                            return;
                        }

                        dispatch(
                            setAlert({
                                show: true,
                                title: "Bank Transaction Failed",
                                body: error.response.data.message,
                                type: "error",
                                size: "md",
                            })
                        );
                    }

                    if (error.response.status === 422) {
                        dispatch(
                            setAlert({
                                show: true,
                                title: "",
                                body: error.response.data.errors.amount[0],
                                type: "error",
                                size: "md",
                            })
                        );
                        return;
                    }

                    if (
                        error.response &&
                        error.response.status > 400 &&
                        error.response.status < 500
                    ) {
                        dispatch(
                            setCreditCardForm({
                                show: true,
                                prefilled: true,
                                closeOnly: true,
                                intent: "tip payment",
                                username: user.login,
                            })
                        );
                    }
                } else {
                    dispatch(
                        setAlert({
                            show: true,
                            title: "",
                            body: "Failed to process tip payment",
                            type: "error",
                            size: "md",
                        })
                    );
                }

                return;
            });
    };

    useEffect(() => {
        setAmount(tipAmount);
    }, [tipAmount]);

    const handleOnSuccessPayment = () => {
        setTipSuccess(true);
    };

    return (
        <>
            <Modal
                className="sendtip-modal"
                show={
                    show &&
                    !showCcVerification &&
                    !showPaymentOptions &&
                    !showCcForm
                }
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className="text-center sendtip-wrapper">
                        <CloseButton
                            onClick={handleClose}
                            style={{
                                position: "absolute",
                                top: "12px",
                                right: "12px",
                            }}
                        />
                        <h6>Send a Gratuity tip to</h6>
                        <h4>@{user.login}</h4>
                        <div className="tip-modal-img">
                            <Avatar
                                pu={user}
                                story={false}
                                size={100}
                                photoSize={55}
                            />
                            <div className="validated">
                                <img src={TickSmallCheck} width={25} />
                            </div>
                        </div>
                        <form
                            id="sendtipform"
                            method="post"
                            onSubmit={handleSubmit}
                        >
                            <div
                                className="cent-in"
                                css={css`
                                    margin-bottom: 15px;
                                `}
                            >
                                <TextField
                                    name="amount"
                                    autoComplete="off"
                                    id="tipAmount"
                                    type="text"
                                    onChange={handleChange}
                                    onKeyDown={handleKeypress}
                                    value={tipAmount}
                                    label="Amount"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                $
                                            </InputAdornment>
                                        ),
                                    }}
                                    inputProps={{
                                        maxLength: 6,
                                        size: 6,
                                    }}
                                    error={!!error}
                                    sx={{
                                        width: "130px",
                                        input: {
                                            fontSize: "26px",
                                        },
                                        "& .MuiInputAdornment-root .MuiTypography-root":
                                            {
                                                fontSize: "26px",
                                            },
                                    }}
                                    variant="standard"
                                />
                                {error ? (
                                    <div
                                        css={css`
                                            color: #d32f2f;
                                            font-weight: 400;
                                            font-size: 0.75rem;
                                            line-height: 1.66;
                                            text-align: center;
                                            margin-top: 3px;
                                        `}
                                    >
                                        {error}
                                    </div>
                                ) : null}
                            </div>
                            <div
                                className="btns clearfix"
                                css={css`
                                    margin-top: 15px;
                                `}
                            >
                                <button
                                    type="button"
                                    className="btn btn-default sendtip blue-btn-hover"
                                    disabled={isLoading || tipAmount <= 0}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowPaymentOptions(true);
                                    }}
                                >
                                    <i className="fa-regular fa-circle-dollar"></i>
                                    &nbsp;
                                    {isLoading ? "SENDING TIP..." : "SEND TIP"}
                                </button>
                                <div className="text-infom">
                                    <div id="nogst">
                                        <p>
                                            {hasGst && (
                                                <span>
                                                    *
                                                    <span className="tipccfees">
                                                        {currency(
                                                            tipfees
                                                        ).format({
                                                            precision: 2,
                                                        })}
                                                    </span>{" "}
                                                    processing fee{" "}
                                                    {hasGst
                                                        ? "plus $" +
                                                          (tipAmount
                                                              ? GSTAmount
                                                              : 0) +
                                                          " GST"
                                                        : ""}{" "}
                                                    will apply.
                                                </span>
                                            )}
                                            {!hasGst && (
                                                <span>
                                                    *
                                                    <span className="tipccfees">
                                                        {currency(
                                                            tipfees
                                                        ).format({
                                                            precision: 2,
                                                        })}
                                                    </span>{" "}
                                                    processing fee will apply.
                                                </span>
                                            )}
                                        </p>
                                        <p>
                                            By clicking "Send Tip" you will be
                                            charged a total of
                                            <span
                                                className="totalamt"
                                                css={css`
                                                    margin-left: 5px;
                                                `}
                                            >
                                                {currency(total).format({
                                                    precision: 2,
                                                })}
                                            </span>{" "}
                                            USD
                                            <br />
                                            <br />
                                            <b>Tips are NOT refundable</b>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            {showPaymentOptions ? (
                <PaymentOptions
                    show={showPaymentOptions}
                    setShow={setShowPaymentOptions}
                    onClickPayNow={handleSubmit}
                    amount={tipAmount}
                    action={TRANSACTION_TYPE.TIP}
                    pu={user}
                    onSuccess={handleOnSuccessPayment}
                    isBusy={isLoading}
                    price={tipAmount}
                    item={post}
                />
            ) : null}
        </>
    );
};

const mapStateToProps = (state) => ({
    showCcVerification: state.ccVerification.showVerify,
    posts: state.post.posts,
    tipRdx: state.privaGlobal.tipForm,
});

export default connect(mapStateToProps)(SendTipModal);
